<template>
    <div class="group">
        <div class="group-scroll">
            <draggable
                    v-model="newGroupList"
                    delay='200'
                    delay-on-touch-only='true'
                    :distance="1"
                    :disabled="isDragging"
                    style="display: flex"
                    @start="onDragStart"
                    @end="onDragEnd"
            >
                <div
                        v-for="(group, index) in newGroupList"
                        :key="index"
                        class="group-title"
                        :class="currGroupId === index ? whiteBg ? 'actived' : 'active' : ''"
                        @click="titleClick(index, group)"
                >
                    {{group.name}}
                </div>
            </draggable>
        </div>
        <span v-if="isEdit" class="group-edit-btns" @click="editGroup">編輯分組</span>
    </div>
</template>

<script>
    import draggable from "vuedraggable";
    import {mapGetters} from "vuex";
    export default {
        name: "GroupList",
        components:{
            draggable
        },
        props:{
            groupList:{
                type: Array,
                default: ()=>[]
            },
            currGroupId:{
                type: Number,
                default: 0
            },
            isEdit:{
                type: Boolean,
                default: true
            },
            whiteBg:{
                type: Boolean,
                default: false
            },
            isDragging: {
                type: Boolean,
                default: true
            }
        },
        data(){
            return{
                newGroupList: []
            }
        },
        watch:{
            groupList:{
                handler(newVal){
                    this.newGroupList = this.$deepClone(this.groupList)
                },
                deep: true
            }
        },
        computed: {...mapGetters(["vrbase"])},
        created() {
            this.newGroupList = this.$deepClone(this.groupList)
        },
        methods:{
            onDragStart(ev){
                ev.item.style.opacity = 0;
                ev.to.ondrop = function (even) {
                    even.preventDefault();
                    even.stopPropagation();
                };
            },
            //移動場景後處理順序
            onDragEnd(event) {
                event.item.style.opacity = 1;
                event.preventDefault();
                event.stopPropagation();
                const oldIndex = event.oldIndex;
                const newIndex = event.newIndex;
                if (oldIndex === newIndex) return;
                this.$emit('dragEnd',this.newGroupList)
            },
            titleClick(index,group){
                this.$emit('titleClick',index,group)
            },
            editGroup(){
                this.$emit('editGroup')
            }
        }
    }
</script>

<style lang="less" scoped>

    /*場景分組*/

    .group {
        display: flex;
        /*padding: 12px 16px;*/
        padding: 12px 0;
        align-items: center;
        justify-content: space-between;

        .group-scroll {
            flex: 1;
            overflow-x: scroll;
            white-space: nowrap;

            &::-webkit-scrollbar {
                display: none;
            }

            .group-title {
                height: 32px;
                line-height: 32px;
                border-radius: 16px;
                padding: 0 15px;
                font-size: 14px;
                background-color: transparent;
                color: #ffffff;
                display: inline-block;
                user-select:none;
                &.active {
                    background-color: rgba(230, 230, 230, 0.4);
                }
                &.actived {
                    background-color: rgba(230, 230, 230, 0.4);
                }
                &:first-child{
                    margin-left: 16px;
                }
                &:last-child{
                    margin-right: 16px;
                }
            }
        }

        .group-edit-btns {
            flex-shrink: 0;
            color: #ffffff;
            height: 32px;
            line-height: 32px;
            margin: 0 16px;
        }
    }
</style>
